import { useState, useEffect } from "react";
import { apiGet } from "../../services/api.service";

export interface Occupation {
	id: number;
	name: string;
	created_at?: string;
}

export function useGetOccupations() {
	const [occupations, setOccupations] = useState<Occupation[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchOccupations = async () => {
			try {
				setLoading(true);
				const response = await apiGet<Occupation[]>("/occupations");

				// Handle both response formats:
				// 1. Direct array from backend: response is the array itself
				// 2. Wrapped response: { success: true, data: [...] }
				let occupationsData: Occupation[] = [];

				if (Array.isArray(response)) {
					// Direct array response from backend
					occupationsData = response;
				} else if (response && typeof response === 'object' && 'success' in response && 'data' in response) {
					// Wrapped response format
					if (response.success && response.data) {
						occupationsData = response.data;
					}
				}

				setOccupations(occupationsData);
			} catch (err) {
				setError(err instanceof Error ? err : new Error("Unknown error"));
			} finally {
				setLoading(false);
			}
		};

		fetchOccupations();
	}, []);

	return { occupations, loading, error };
}
